import { DataOptions } from "../../types/data.types";
import { Data } from "../Data";
import { SettingsEmployee, SettingsEmployeeData } from "./SettingsEmployee";

export interface GroupMemberListApiResponse {
  employees: SettingsEmployeeData[];
  overlapEmployees: SettingsEmployeeData[];
}

export interface GroupMemberListOptions extends Omit<DataOptions, "api" | "callback" | "method"> {
  resolve: (data: SettingsGroupMemberList, cached: boolean) => void;
  postData: {
    jobDefinitionIds: string[];
    locationIds: string[];
    managerIds: (string | undefined)[];
  };
}

export class SettingsGroupMemberList extends Data {
  managerMemberOverlap: SettingsEmployee[];
  employees: SettingsEmployee[];

  constructor(options: GroupMemberListOptions) {
    super({
      api: "/Group/ListEmployeesByJobDefinitionsAndLocations",
      callback: () => {
        options.resolve(this, false);
      },
      method: "post",
      ...options
    });

    this.managerMemberOverlap = [];
    this.employees = [];
  }

  onDataReceived(data: GroupMemberListApiResponse): void {
    data.employees.forEach((e: SettingsEmployeeData) =>
      this.employees.push(new SettingsEmployee(e))
    );
    data.overlapEmployees.forEach((e: SettingsEmployeeData) =>
      this.managerMemberOverlap.push(new SettingsEmployee(e))
    );
  }
}
